document.addEventListener('DOMContentLoaded', () => {
  const grids = document.querySelectorAll('ul.grid, .product-grid');

  grids.forEach((grid) => {
    const items = Array.from(grid.children).filter((el) => el.querySelector && el.querySelector('.card-wrapper'));
    if (items.length < 2) return;

    const available = [];
    const soldOut = [];

    items.forEach((item) => {
      const badge = item.querySelector('.card__badge .badge');
      const isSoldOut = badge && badge.textContent.trim().toLowerCase().indexOf('sold out') !== -1;
      (isSoldOut ? soldOut : available).push(item);
    });

    if (soldOut.length === 0 || available.length === 0) return;

    available.concat(soldOut).forEach((item) => grid.appendChild(item));
  });
});
